import { render, staticRenderFns } from "./AddLeadRecipientsPopup.vue?vue&type=template&id=387c80f7&"
import script from "./AddLeadRecipientsPopup.vue?vue&type=script&lang=js&"
export * from "./AddLeadRecipientsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports